<!--
@Time : 2020/12/1 2:51 下午
@Author : yekong
@File : haoshileixing.vue
@Software : PhpStorm
-->
<template>
  <div>
    <div class="hslx">
      <div class="haoshibt">
        <div class="item">
          环节个数
        </div>
        <div class="item">
          用电报装<br>申请
        </div>
        <div class="item">
          供电方案<br>
          答复
        </div>
        <div class="item">
          办理道路<br>
          挖掘许可
        </div>
        <div class="item">
          完成工程<br>
          施工
        </div>
        <div class="item">竣工检验</div>
        <div class="item">装表接电</div>
      </div>
      <div class="haoshibody">
        <div class="item2">
          <div class="hj">环节<br>个数</div>
        </div>
        <div class="item2 bg2">
          <zhuzhuangtu></zhuzhuangtu>
        </div>
        <div class="item2">
          <zhuzhuangtu></zhuzhuangtu>
        </div>
        <div class="item2 bg2">
          <zhuzhuangtu></zhuzhuangtu>
        </div>
        <div class="item2">
          <zhuzhuangtu></zhuzhuangtu>
        </div>
        <div class="item2 bg2">
          <zhuzhuangtu></zhuzhuangtu>
        </div>
        <div class="item2">
          <zhuzhuangtu></zhuzhuangtu>
        </div>
      </div>
      <div class="haoshibody2">
        <div class="bj">
          <span></span>
          北京
        </div>
        <div class="bj">
          <span class="bg3"></span>
          大连
        </div>
        <div class="bj">
          <span class="bg4"></span>
          上海
        </div>
        <div class="bj">
          <span class="bg5"></span>
          深圳
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import zhuzhuangtu from "@/components/huodedianli/zhuzhuangtu";

export default {
  name: "haoshileixing",
  components: {zhuzhuangtu},
  data: function () {
    return {}
  },
  props: {
    top: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  created: function () {

  },
  filters: {},
  methods: {},
  mounted() {
  },
}
</script>

<style lang="scss" scoped>
.haoshibt {
  width: 1153px;
  height: 102px;

  background: #404C6E;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: row;
  margin-top: 28px;

  .item {
    font-size: 28px;
    font-family: PingFang;
    font-weight: 800;
    color: #FFFFFF;
    width: 160px;
    display: flex;
    line-height: 45px;
    text-align: center;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: nowrap;
    flex-direction: row;
  }
}

.haoshibody {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: nowrap;
  flex-direction: row;
  height: 164px;
  width: 1153px;
  background: url("../../assets/banma.png") bottom center no-repeat;

  .item2 {
    width: 160px;
    height: 164px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: nowrap;
    flex-direction: row;
    font-size: 28px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;

    line-height: 40px;
  }
}

.bg2 {
  background: rgba(64, 76, 110, 0.2);
}

.haoshibody2 {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: row;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  margin-top: 30px;

  .bj {
    margin-right: 15px;
    margin-left: 15px;

    span {
      width: 25px;
      height: 16px;
      background: #4FC7EA;
      display: inline-block;
    }
  }
}

.bg3 {
  background: rgba(255, 126, 75, 1) !important;
}

.bg4 {
  background: rgba(136, 43, 205, 1) !important;
}

.bg5 {
  background: rgba(60, 175, 133, 1) !important;
}

.hslx {
  margin-left: 26px;
}
.hj{
  padding-top: 50px;
}
</style>
